import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { format, parseISO } from "date-fns";

import { ReactComponent as ArrowDowRedIcon } from "../../../../build/images/nps-dashboard-icons/arrow_drop_down-red.svg";
import { ReactComponent as EmailIcon } from "../../../../build/images/nps-dashboard-icons/channels/e-mail.svg";
import { ReactComponent as GbmIcon } from "../../../../build/images/nps-dashboard-icons/channels/gbm.svg";
import { ReactComponent as MessengerIcon } from "../../../../build/images/nps-dashboard-icons/channels/messenger.svg";
import { ReactComponent as SmsIcon } from "../../../../build/images/nps-dashboard-icons/channels/new-sms-icon.svg";
import { ReactComponent as TelegramIcon } from "../../../../build/images/nps-dashboard-icons/channels/telegram.svg";
import { ReactComponent as VoiceIcon } from "../../../../build/images/nps-dashboard-icons/channels/voice.svg";
import { ReactComponent as WebchatIcon } from "../../../../build/images/nps-dashboard-icons/channels/webchat.svg";
import { ReactComponent as WhatsappIcon } from "../../../../build/images/nps-dashboard-icons/channels/whatsapp.svg";
import { ReactComponent as TEAMSSMALL } from "../../../../build/images/channels/teamsSmall.svg";

import "./nps-date-four.css";
import Paperplane from "../../../Loading/Paperplane";
import { getCsatChannelCall, getSentNpsCsatCall } from "../../../../actions";
import axios from "axios";
import { subAndFormatMonths } from "../../../../utils/subAndFormatMonths";

export default function NpsDateFour() {
  const agentDashboardFilter = useSelector(
    (state) => state.agentDashboardFilter
  );
  const cardsOfCallCenterDash = useSelector(
    (state) => state.cardsOfCallCenterDash
  );

  const [csatValues, setCsatValues] = useState({
    csatMes: 0,
    csatPassado: 0,
    mesPassado: false,
  });
  const [channelsValue, setChannelsValue] = useState({
    voz: 0,
    whatsapp: 0,
    gbm: 0,
    messenger: 0,
    email: 0,
    sms: 0,
    telegram: 0,
    webchat: 0,
    teams: 0,
  });
  const [loadingChannel, setLoadingChannel] = useState(false);
  const [loading, setLoading] = useState(false);

  const csatChannelData = [
    { icon: <VoiceIcon />, percentage: channelsValue.voz, channel: "Voz" },
    {
      icon: <WhatsappIcon />,
      percentage: channelsValue.whatsapp,
      channel: "Whatsapp",
    },
    // { icon: <GbmIcon />, percentage: channelsValue.gbm, channel: "GBM" },
    { icon: <TEAMSSMALL />, percentage: channelsValue.teams, channel: "Teams" },
    {
      icon: <MessengerIcon />,
      percentage: channelsValue.messenger,
      channel: "Messenger",
    },
    { icon: <EmailIcon />, percentage: channelsValue.email, channel: "E-mail" },
    { icon: <SmsIcon />, percentage: channelsValue.sms, channel: "Sms" },
    {
      icon: <TelegramIcon />,
      percentage: channelsValue.telegram,
      channel: "Telegram",
    },
    {
      icon: <WebchatIcon />,
      percentage: channelsValue.webchat,
      channel: "Webchat",
    },
  ];

  async function getCsatResultV2(source) {
    setLoading(true);
    let updatedCsatValues = {
      csatMes: 0,
      csatPassado: 0,
      mesPassado: false,
    };
    const responseCurrentDate = await getSentNpsCsatCall(
      format(
        new Date(agentDashboardFilter.initialDateAgenteScreen),
        "yyyy-MM-dd"
      ),
      format(new Date(agentDashboardFilter.finalDateAgentScreen), "yyyy-MM-dd"),
      agentDashboardFilter.channelSelectedAgentScreen
        .map((option) => option.id)
        .join(","),
      agentDashboardFilter.avaliationSelectedAgentScreen
        .map((option) => option.id)
        .join(","),
      source
    );
    const hasResponseCurrentDate =
      !!responseCurrentDate && responseCurrentDate.status === 200;
    if (hasResponseCurrentDate) {
      const data = responseCurrentDate.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        const csatInfos = data.find((datum) => {
          return datum.tipo_pesquisa === "CSAT";
        });
        const hasCsatInfos = !!csatInfos;
        if (hasCsatInfos) {
          const grade = Number(csatInfos.nota);
          const isGradeANumber = typeof grade === "number";
          if (isGradeANumber) {
            updatedCsatValues.csatMes = grade;
          }
        }
      }
    }

    const initialDateOfPastMonth = subAndFormatMonths(
      format(
        new Date(agentDashboardFilter.initialDateAgenteScreen),
        "yyyy-MM-dd"
      ),
      1
    );
    const finalDateOfPastMonth = subAndFormatMonths(
      format(new Date(agentDashboardFilter.finalDateAgentScreen), "yyyy-MM-dd"),
      1
    );
    const responsePastMonth = await getSentNpsCsatCall(
      initialDateOfPastMonth,
      finalDateOfPastMonth,
      agentDashboardFilter.channelSelectedAgentScreen
        .map((option) => option.id)
        .join(","),
      agentDashboardFilter.avaliationSelectedAgentScreen
        .map((option) => option.id)
        .join(","),
      source
    );
    const hasResponsePastMonth =
      !!responsePastMonth && responsePastMonth.status === 200;
    if (hasResponsePastMonth) {
      const data = responsePastMonth.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        const csatInfos = data.find((datum) => {
          return datum.tipo_pesquisa === "CSAT";
        });
        const hasCsatInfos = !!csatInfos;
        if (hasCsatInfos) {
          const pastValue = Number(csatInfos.nota);
          const isPastValueANumber = typeof pastValue === "number";

          if (isPastValueANumber) {
            const dateStartObj = parseISO(initialDateOfPastMonth);
            let formatedStartDate = "";
            const isDateStartObjValid = !!dateStartObj;
            if (isDateStartObjValid) {
              formatedStartDate = format(dateStartObj, "dd/MM/yyyy");
            }

            const dateEndObj = parseISO(finalDateOfPastMonth);
            let formatedEndDate = "";
            const isDateEndObjValid = !!dateEndObj;
            if (isDateEndObjValid) {
              formatedEndDate = format(dateEndObj, "dd/MM/yyyy");
            }
            const currentValue = updatedCsatValues.csatMes;
            const comparation = currentValue - pastValue;
            updatedCsatValues.csatPassado = comparation;
            updatedCsatValues.mesPassado = (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span>{formatedStartDate}</span>
                <span>{formatedEndDate}</span>
              </div>
            );
          }
        }
      }
    }

    setCsatValues(updatedCsatValues);
    setLoading(false);
  }

  async function getCsatChannel(source) {
    setLoadingChannel(true);
    const response = await getCsatChannelCall(
      format(
        new Date(agentDashboardFilter.initialDateAgenteScreen),
        "yyyy-MM-dd"
      ),
      format(new Date(agentDashboardFilter.finalDateAgentScreen), "yyyy-MM-dd"),
      agentDashboardFilter.channelSelectedAgentScreen
        .map((option) => option.id)
        .join(),
      agentDashboardFilter.avaliationSelectedAgentScreen
        .map((option) => option.id)
        .join(),
      source
    );

    if (response && response.status === 200) {
      const data = response.data;

      let objValues = {
        voz: 0,
        whatsapp: 0,
        gbm: 0,
        messenger: 0,
        email: 0,
        sms: 0,
        telegram: 0,
        webchat: 0,
        teams: 0,
      };

      if (data.length > 0) {
        data.forEach((datum) => {
          switch (datum.idmidia) {
            case 1:
              objValues = { ...objValues, voz: datum.resultado };
              break;
            case 2:
              objValues = { ...objValues, webchat: datum.resultado };
              break;
            case 3:
              objValues = { ...objValues, email: datum.resultado };
              break;
            case 4:
              objValues = { ...objValues, messenger: datum.resultado };
              break;
            case 5:
              objValues = { ...objValues, whatsapp: datum.resultado };
              break;
            case 8:
              objValues = { ...objValues, telegram: datum.resultado };
              break;
            case 11:
              objValues = { ...objValues, gbm: datum.resultado };
              break;
            case 12:
              objValues = { ...objValues, sms: datum.resultado };
              break;
            case 15:
              objValues = { ...objValues, teams: datum.resultado };
            default:
              break;
          }
        });

        setChannelsValue(objValues);
      } else {
        setChannelsValue({
          voz: 0,
          whatsapp: 0,
          gbm: 0,
          messenger: 0,
          email: 0,
          sms: 0,
          telegram: 0,
          webchat: 0,
          teams: 0,
        });
      }
      setLoadingChannel(false);
    } else {
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setLoadingChannel(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  }

  const getAllData = async (sourceResult, sourceChannel) => {
    await getCsatResultV2(sourceResult);
    await getCsatChannel(sourceChannel);
  };

  function renderPastPeriodInformation(csatValues) {
    const isPastCsatNegative = csatValues.csatPassado < 0;
    if (isPastCsatNegative) {
      return (
        <span className="csat-month-content__span">
          <ArrowDowRedIcon />

          <h5 className="csat-month-content__span__number">
            {csatValues.csatPassado}%
          </h5>
          <h5 className="csat-month-content__span__text">vs</h5>
          <h5 className="csat-month-content__span__text">
            {csatValues.mesPassado}
          </h5>
        </span>
      );
    }

    const isPastCsatPositive = csatValues.csatPassado > 0;
    if (isPastCsatPositive) {
      return (
        <span className="csat-month-content__span">
          <h5 className="csat-month-content__span__number csat-month-content__span__number--green">
            {csatValues.csatPassado}%
          </h5>
          <h5 className="csat-month-content__span__text">vs</h5>
          <h5 className="csat-month-content__span__text">
            {csatValues.mesPassado}
          </h5>
        </span>
      );
    }
    return null;
  }

  useEffect(() => {
    const sourceResult = axios.CancelToken.source();
    const sourceChannel = axios.CancelToken.source();

    if (!!agentDashboardFilter) {
      getAllData(sourceResult, sourceChannel);
    }

    return () => {
      sourceResult.cancel("Operation canceled by the user. (sourceResult)");
      sourceChannel.cancel("Operation canceled by the user. (sourceChannel)");
    };
  }, [agentDashboardFilter]);

  return (
    <section className="nps-date-four">
      {cardsOfCallCenterDash.card9 && (
        <div className="csat-month">
          {loading ? (
            <Paperplane className="nps-date-four__loading" />
          ) : (
            <div className="csat-month-content">
              <h5 className="csat-month-content__h5">CSAT do Período</h5>
              <h1 className="csat-month-content__h1">{csatValues.csatMes}%</h1>
              {renderPastPeriodInformation(csatValues)}
            </div>
          )}
        </div>
      )}

      {cardsOfCallCenterDash.card10 && (
        <div className="csat-by-channel">
          <header className="csat-by-channel__header">
            <h6>CSAT por canal</h6>
          </header>

          <div className="channels-percentage">
            {loadingChannel ? (
              <Paperplane className="nps-date-four__loading" />
            ) : (
              csatChannelData.map((data, index) => (
                <div key={index} className="content-container">
                  <h1 className="content-container__number">
                    {data.percentage}%
                  </h1>

                  <span className="csat-channel-container">
                    {data.icon}
                    <h6 className="csat-channel-container__h6">
                      {data.channel}
                    </h6>
                  </span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </section>
  );
}
